import { render } from "./EmailCreate.vue?vue&type=template&id=ca69eb88&scoped=true"
import script from "./EmailCreate.vue?vue&type=script&lang=js"
export * from "./EmailCreate.vue?vue&type=script&lang=js"

import "./EmailCreate.vue?vue&type=style&index=0&id=ca69eb88&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca69eb88"]])

export default __exports__